// Token storage and auth utilities

export const setAuthToken = (token) => {
    localStorage.setItem('authToken', token);
  };
  
  export const getAuthToken = () => {
    return localStorage.getItem('authToken');
  };
  
  export const setUser = (user) => {
    localStorage.setItem('user', JSON.stringify(user));
  };
  
  export const getUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  };
  
  export const clearAuth = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  };
  
  export const isAuthenticated = () => {
    return !!getAuthToken();
  };
  
  export const getUserRole = () => {
    const user = getUser();
    return user?.role || null;
  };